import { render, staticRenderFns } from "./VeJwJxrwModal.vue?vue&type=template&id=e828e580"
import script from "./VeJwJxrwModal.vue?vue&type=script&lang=js"
export * from "./VeJwJxrwModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports